import { render, staticRenderFns } from "./InicioComponent.vue?vue&type=template&id=a67a14b4&"
import script from "./InicioComponent.vue?vue&type=script&lang=js&"
export * from "./InicioComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports